import axios, { CancelTokenSource } from 'axios';
import { getWhenAuthorized, patchWhenAuthorized, postWhenAuthorized } from './api';

export interface IGroupRequest {
    description?: string;
    icon?: string;
    alias?: string;
    name?: string;
    showMembers?: boolean;
    showMembersInfo?: string;
    canSendEmail?: string;
    sendIntroMessage?: string;
    dropzoneImageDataUri?: string;
}

export interface ICreateGroupResponsibleRequest {
    personId: number;
    role: string;
}

export interface IDeleteGroupResponsibleRequest {
    personId: number;
}

export const getGroupMeetings = async (groupId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}/meetings`, cancelTokenSource);

export const getGroupActivityStats = async (groupId: string, from: Date, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}/activitystats/${from.getFullYear() + '-' + (from.getMonth() + 1) + '-' + from.getDate()}`, cancelTokenSource);

export const getGroupActivityStatsCsv = async (groupId: string, from: Date, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}/activitystatscsv/${from.getFullYear() + '-' + (from.getMonth() + 1) + '-' + from.getDate()}`, cancelTokenSource);

export const getBouncedGroupMembers = async (groupId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}/bounced/members`, cancelTokenSource);

export const getGroupMembers = async (groupId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}/members`, cancelTokenSource);

export const downloadGroupMembers = async (groupId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}/download/members.csv`, cancelTokenSource, 'blob');

export const getGroup = async (groupId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}`, cancelTokenSource);

export const updateGroup = async (groupId: string, request: IGroupRequest, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        return await patchWhenAuthorized(() => `/api/group/${groupId}`, request, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }
    return undefined;
}

export const setGroupResponsible = async (groupId: string, request: ICreateGroupResponsibleRequest, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        return await postWhenAuthorized(() => `/api/group/${groupId}/responsible`, request, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }
    return undefined;
}

export const deleteGroupResponsible = async (groupId: string, request: IDeleteGroupResponsibleRequest, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        return await patchWhenAuthorized(() => `/api/group/${groupId}/responsible`, request, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }
    return undefined;
}